var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01953 13.43V47.15C4.01953 49.28 5.73953 51 7.86953 51H39.1795C41.3095 51 43.0295 49.28 43.0295 47.15V13.43C43.0295 11.3 41.3095 9.57996 39.1795 9.57996H7.86953C5.73953 9.57996 4.01953 11.31 4.01953 13.43Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01953 13.44V47.14C4.01953 49.27 5.74953 51 7.87953 51H39.1795C41.3095 51 43.0395 49.27 43.0395 47.14V13.44C43.0395 11.31 41.3095 9.57996 39.1795 9.57996H7.86953C5.73953 9.57996 4.01953 11.31 4.01953 13.44Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5091 33.99H23.5191V51H14.0391V35.45C14.0391 34.64 14.6991 33.99 15.5091 33.99Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5393 33.99H23.5293V51H32.9993V35.45C32.9993 34.64 32.3493 33.99 31.5393 33.99Z",
    fill: "#FFCF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5091 33.99H23.5191V51H14.0391V35.45C14.0391 34.64 14.6991 33.99 15.5091 33.99Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5393 33.99H23.5293V51H32.9993V35.45C32.9993 34.64 32.3493 33.99 31.5393 33.99Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2798 27.6899H11.5898",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2798 21.9399H11.5898",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2798 16.2H11.5898",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7695 27.6899H35.4495",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7695 21.9399H35.4495",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0609 22.86C43.0973 22.86 47.9909 17.9665 47.9909 11.93C47.9909 5.89353 43.0973 1 37.0609 1C31.0244 1 26.1309 5.89353 26.1309 11.93C26.1309 17.9665 31.0244 22.86 37.0609 22.86Z",
    fill: "#FFCF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0609 22.86C43.0973 22.86 47.9909 17.9665 47.9909 11.93C47.9909 5.89353 43.0973 1 37.0609 1C31.0244 1 26.1309 5.89353 26.1309 11.93C26.1309 17.9665 31.0244 22.86 37.0609 22.86Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1592 10.1101H38.8792V7.82006C38.8792 7.26006 38.4292 6.81006 37.8692 6.81006H36.2492C35.6892 6.81006 35.2392 7.26006 35.2392 7.82006V10.1001H32.9592C32.3992 10.1001 31.9492 10.5501 31.9492 11.1101V12.7301C31.9492 13.2901 32.3992 13.7401 32.9592 13.7401H35.2392V16.0201C35.2392 16.5801 35.6892 17.0301 36.2492 17.0301H37.8692C38.4292 17.0301 38.8792 16.5801 38.8792 16.0201V13.7401H41.1592C41.7192 13.7401 42.1692 13.2901 42.1692 12.7301V11.1101C42.1692 10.5601 41.7192 10.1101 41.1592 10.1101Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1592 10.1101H38.8792V7.82006C38.8792 7.26006 38.4292 6.81006 37.8692 6.81006H36.2492C35.6892 6.81006 35.2392 7.26006 35.2392 7.82006V10.1001H32.9592C32.3992 10.1001 31.9492 10.5501 31.9492 11.1101V12.7301C31.9492 13.2901 32.3992 13.7401 32.9592 13.7401H35.2392V16.0201C35.2392 16.5801 35.6892 17.0301 36.2492 17.0301H37.8692C38.4292 17.0301 38.8792 16.5801 38.8792 16.0201V13.7401H41.1592C41.7192 13.7401 42.1692 13.2901 42.1692 12.7301V11.1101C42.1692 10.5601 41.7192 10.1101 41.1592 10.1101Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBusiness);
export default __webpack_public_path__ + "static/media/NewBusiness.0b563aa4032be3e4921ce4aadafe16cf.svg";
export { ForwardRef as ReactComponent };